class MobileNav extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-nav-trigger]');
    this.panel = this.querySelector('[data-nav-panel]');
    this.backdrop = this.querySelector('[data-nav-backdrop]');

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', () => this.toggle());
    this.backdrop?.addEventListener('click', () => this.close());

    this.querySelectorAll('[data-submenu-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => this.toggleSubmenu(btn));
    });

    this.onDocKeydown = (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    };
    document.addEventListener('keydown', this.onDocKeydown);
    this.classList.add('is-initialized');
    this._setHeaderPosition();
  }

  _setHeaderPosition() {
    const headerEl = document.querySelector('.section-header');
    if (headerEl) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        Math.floor(headerEl.getBoundingClientRect().bottom) + 'px'
      );
    }
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onDocKeydown);
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.panel.classList.add('mobile-nav__panel--open');
    this.backdrop.classList.add('mobile-nav__backdrop--active');
    this.trigger.setAttribute('aria-expanded', 'true');

    const header = this.closest('.header-wrapper');
    if (header) header.preventHide = true;

    this._setHeaderPosition();
    trapFocus(this.panel, this.panel.querySelector('a, button'));
  }

  close() {
    this.isOpen = false;
    this.panel.classList.remove('mobile-nav__panel--open');
    this.backdrop.classList.remove('mobile-nav__backdrop--active');
    this.trigger.setAttribute('aria-expanded', 'false');

    const header = this.closest('.header-wrapper');
    if (header) header.preventHide = false;

    removeTrapFocus(this.trigger);
  }

  toggleSubmenu(btn) {
    const id = btn.getAttribute('data-submenu-trigger');
    const submenu = this.querySelector(`[data-submenu="${id}"]`);
    if (!submenu) return;

    const isExpanded = btn.getAttribute('aria-expanded') === 'true';

    if (!isExpanded) {
      this.querySelectorAll('[data-submenu-trigger][aria-expanded="true"]').forEach((other) => {
        if (other === btn) return;
        other.setAttribute('aria-expanded', 'false');
        const otherId = other.getAttribute('data-submenu-trigger');
        const otherMenu = this.querySelector(`[data-submenu="${otherId}"]`);
        otherMenu?.classList.remove('mobile-nav__submenu--open');
      });
    }

    btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    submenu.classList.toggle('mobile-nav__submenu--open', !isExpanded);
  }
}

if (!customElements.get('mobile-nav')) {
  customElements.define('mobile-nav', MobileNav);
}
